import { FC } from "react";
import { TemplateType } from "@commons-monorepo/index";
import styles from "./products-grid.module.css";
import { ProductsGridProps, ProductsGridType } from "./products-grid.types";

const ProductsGrid: FC<ProductsGridProps> = ({
  className,
  children,
  theme
}) => {
  const type =
  TemplateType.PRODUCTS_GRID_1 === theme.template.PRODUCTS_GRID ?
  ProductsGridType.Type1 :
  TemplateType.PRODUCTS_GRID_2 === theme.template.PRODUCTS_GRID ?
  ProductsGridType.Type2 :
  TemplateType.PRODUCTS_GRID_3 === theme.template.PRODUCTS_GRID ?
  ProductsGridType.Type3 :
  TemplateType.PRODUCTS_GRID_4 === theme.template.PRODUCTS_GRID ?
  ProductsGridType.Type4 :
  TemplateType.PRODUCTS_GRID_5 === theme.template.PRODUCTS_GRID ?
  ProductsGridType.Type5 :
  ProductsGridType.Type3;

  return (
    <div
      id='products-main-grid'
      className={`${styles.productsGridWrapper} ${styles[type]} ${className}`}>

      {children}
    </div>);

};

export default ProductsGrid;